import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
	
import styles from "./IndEvent.module.css"


const AnnouncementsTopbar = ({ event, mainLoading, setIsLoading, isLoading, selectedChannel, setMainReloadKey }) => {
	const param = useParams();
	const [announcementMsg, setAnnouncementMsg] = useState("")


	const handleSubmit = async () => {
      setIsLoading(true)

      const userId = localStorage.getItem("_id")
      const expiry = localStorage.getItem("expiry")
      if (!userId || !expiry) {
        localStorage.removeItem("_id")
        localStorage.removeItem("expiry")
        window.location = "/connect"
      }

      try {
        const body = {
          channel: selectedChannel,
          msg: announcementMsg
        }

        const res = await axios.post(`/api/events/send-announcement/${param.event_id}`, body, {
          headers: {
            'x-user-id': userId,
            'x-expiry': expiry
          }
        });

        setAnnouncementMsg("")
        setMainReloadKey((prevMainKey) => prevMainKey + 1);
      } catch (err) {
        localStorage.removeItem("_id")
        localStorage.removeItem("expiry")
        window.location = "/connect"
      }

      setIsLoading(false)
	}

	return (
		<div className={styles.guestii_topbar}>
			<div className={styles.guestii_topbar_search}>
				<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
				{announcementMsg === "" && <p className={`${styles.s1}`}>Send a message to your {selectedChannel}...</p>}

				<input
					type="text"
					className={styles.s1}
					onChange={(input) => setAnnouncementMsg(input.target.value)}
					value={announcementMsg}
				/>
			</div>

			<button className={styles.guestii_topbar_add} disabled={mainLoading || isLoading || announcementMsg === ""} onClick={() => handleSubmit()}>
				<i className={`fa-solid fa-envelope ${styles.s3}`}></i>
				<p className={`${styles.s1}`}>Send</p>
			</button>
		</div>
	)
}

const AnnouncementsDisplay = ({ event, mainLoading, setIsLoading, isLoading, selectedChannel, setMainReloadKey }) => {
	const param = useParams();
	const [announcements, setAnnouncements] = useState({
		guestiis: [],
		team: []
	})

	useEffect(() => {
		const handleNodes = async () => {
			setIsLoading(true)

			setAnnouncements({
				guestiis: event.announcements.filter(a => a.channel === "Guestiis"),
				team: event.announcements.filter(a => a.channel === "Team")
			})

			setIsLoading(false)
		}

		handleNodes()
	}, [event]);
	

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const dd = String(date.getDate()).padStart(2, '0');
	    const mm = String(date.getMonth() + 1).padStart(2, '0');
	    const yy = String(date.getFullYear()).slice(-2);

	    return `${dd}/${mm}/${yy}`;
	}

	function formatTime(dateString) {
	  	const date = new Date(dateString);

	  	const hours = date.getHours();
	  	const minutes = String(date.getMinutes()).padStart(2, '0');
	  	const seconds = String(date.getSeconds()).padStart(2, '0');

	  	return `${hours}:${minutes}:${seconds}`;
	}

	const processAnnouncements = (announcements) => {
		const now = new Date();
		const announcementsSorted = [...announcements].sort((a, b) => new Date(a.sent_date) - new Date(b.sent_date));

 		return [...announcementsSorted.reverse()]
	}

	const handleDelete = async (announcement) => {
		const confirmDelete = await window.confirm("Are you sure you want to delete this message?")
		if (!confirmDelete) { return; }
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}

	  	try {
		    const res = await axios.delete(`/api/events/delete-announcement/${param.event_id}/${announcement._id}`, {
		      	headers: {
		        	'x-user-id': userId,
		        	'x-expiry': expiry
		      	}
		    });

		    setMainReloadKey((prevKey) => prevKey + 1);
	  	} catch (err) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
	  	}

  		setIsLoading(false)
	}

	return (
		<>
			{(!isLoading && !mainLoading)
				?
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
					>
						{announcements[selectedChannel.toLowerCase()].length > 0
							?
								<div className={styles.outer_announcements}>
									{processAnnouncements(announcements[selectedChannel.toLowerCase()]).map((a, i) => {
										const isLast = i === announcements[selectedChannel.toLowerCase()].length - 1

										return (
											<div className={`${styles.annoucement_msg_container} ${isLast && styles.paddingLastItem}`}>
												<div className={styles.event_line}>
													<div className={styles.line_circle}/>
													{!isLast && <div className={styles.line}/>}
												</div>

												<div className={styles.annoucement_msg}>
													<div className={styles.announcement_content}>
														<p className={styles.xs2}>{formatDate(a.sent_date)} @ {formatTime(a.sent_date)} by <span>{a.source.first_name} {a.source.last_name}</span></p>
					            						<p className={styles.s1}>{a.message}</p>
					            					</div>

					            					<button className={styles.annoucement_delete} onClick={() => handleDelete(a)}>
					            						<i className={`fa-solid fa-trash-can ${styles.s1}`}></i>
					            					</button>
					            				</div>
											</div>
										)
									})}
								</div>
							: <div className={styles.invite_first}><p className={styles.m1}>Send your first message to your {selectedChannel}!</p></div>
						}
					</div>
				:
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
					>
						<div className={styles.outer_announcements}>
							{Array.from({ length: 30 }).map((_, i) => {
								const isLast = i === 29

								return (
									<div className={`${styles.annoucement_msg_container} ${isLast && styles.paddingLastItem}`}>
										<div className={styles.event_line}>
											<div className={styles.line_circle}/>
											{(!isLast) && <div className={styles.line}/>}
										</div>

										<div className={`${styles.annoucement_msg} shine-animation`}>
											<div className={styles.announcement_content} style={{ visibility: 'hidden' }}>
												<p className={styles.xs2}>loading...</p>
			            						<p className={styles.s1}>loading...</p>
			            					</div>
			            				</div>
									</div>
								)
							})}
						</div>
					</div>
			}
		</>


	)
}

const AnnouncementsModule = ({ event, mainLoading, selectedChannel, setMainReloadKey }) => {
	const [isLoading, setIsLoading] = useState(true)

	return (
		<>
			<AnnouncementsTopbar
				event={event}
				mainLoading={mainLoading}
				setIsLoading={setIsLoading}
				isLoading={isLoading}
				selectedChannel={selectedChannel}
				setMainReloadKey={setMainReloadKey}
			/>

			<AnnouncementsDisplay
				event={event}
				mainLoading={mainLoading}
				setIsLoading={setIsLoading}
				isLoading={isLoading}
				selectedChannel={selectedChannel}
				setMainReloadKey={setMainReloadKey}
			/>
		</>
	)
}


export default AnnouncementsModule;